import "@/components/error-monitoring";
import { createRoot } from "react-dom/client";
import { App as NewApp } from "./app/app";
import { initGoogleAnalytics } from "@/lib/analytics/google-analytics";

// Global styles
import "./index.css";

initGoogleAnalytics();

const root = document.getElementById("root");

if (root === null) {
	throw new Error("Root element not found");
}

createRoot(root).render(<NewApp />);
